import type { WidgetContainer as LiveWidgetContainer } from './WidgetContainer/WidgetContainer';
import { injectable } from 'src/features/ioc';

@injectable()
export class RendererWidgetContainerRegistry {
    readonly #containers = new Map<string, LiveWidgetContainer>();

    register(containerId: string, container: LiveWidgetContainer): () => void {
        this.#containers.set(containerId, container);
        return () => {
            if (this.#containers.get(containerId) === container) {
                this.#containers.delete(containerId);
            }
        };
    }

    get(containerId: string): LiveWidgetContainer | undefined {
        return this.#containers.get(containerId);
    }
}
